const strings = {
  'en': {
    'princeIdPresent': 'The Prince of Insulae Draconis will be present',
    'princessIdPresent': 'The Princess of Insulae Draconis will be present',
    'princeAndPrincessIdPresent': 'The Prince and Princess of Insulae Draconis will be present',

    'princeNordmarkPresent': 'The Prince of Nordmark will be present',
    'princessNordmarkPresent': 'The Princess of Nordmark will be present',
    'princeAndPrincessNordmarkPresent': 'The Prince and Princess of Nordmark will be present',

    'kingPresent': 'The King will be present',
    'queenPresent': 'The Queen will be present',
    'kingAndQueenPresent': 'The King and Queen will be present',
    'royaltyPresent': 'Royalty Present',

    'heavy': 'Armoured Combat',
    'heavyScheduled': 'Armoured Combat is scheduled',
    'fencing': 'Fencing',
    'fencingScheduled': 'Fencing is scheduled',
    'archery': 'Archery',
    'archeryScheduled': 'Archery is scheduled',
    'artsci': 'Arts and Sciences',
    'artsciScheduled': 'Arts and Sciences activities are scheduled',
    'dancing': 'Dancing',
    'dancingScheduled': 'Dancing is scheduled',
    'online': 'Takes place online',
    'importantInfo': 'Important Info',
    'cancelled': 'Cancelled',
    'cancelledLong': 'This event has been cancelled',
    'contactStaff': 'Please contact the event staff for further information.',

    'bidList': 'Bid List',
    'addEvent': 'Add an event to the calendar',

    'hideLocal': 'Hide local/non-official events',
    'showLocal': 'Show local/non-official events',

    'hideCancelled': 'Hide cancelled events',
    'showCancelled': 'Show cancelled events',

    'eventsApprovedByChronicler': 'Events which have been approved by the Chronicler as official have a white background.',
    'upcomingEvents': 'Upcoming Events',

    // Columns of the calendar

    'date': 'Date',
    'group': 'Group',
    'event': 'Event',
    'info': 'Info',

    // When loading, this shows "Loading calendar attempt 1", "Loading calendar attempt 2", and so on
    'loadingAttempt': 'Loading calendar attempt',
    'loadFailed': 'Calendar failed to load',

    'eventNotFound': 'This event was not found in the calendar.',

    // Strings for the event pages

    'hostedBy': 'Hosted by',
    'viewMap': 'View on Google Maps',
    'siteAddress': 'Site address',
    'siteInfo': 'Site information',
    'cost': 'Pricing',
    'reservation': 'Reservation',
    'payment': 'Payment',
    'joinOnline': 'Join the online meeting',
    'pwInfo': 'Password information',
    'eventSteward': 'Event steward',
    'visitWebsite': 'Visit the event website',
    'visitFB': 'Follow this event on Facebook',

    'chronOfficial': 'This is an official event approved by the Kingdom Chronicler',
    'chronUpdated': 'This event has been updated since being approved by the Chronicler',
    'chronPending': 'This event is pending review by the Chronicler',
    'chronUnofficial': 'The Kingdom Chronicler requires more information before listing this as an official event',
    'chronLocal': 'This local event is not published in the Kingdom Newsletter',
    'chronOnline': 'This is an online-only event',

    // Info pages

    'appliesTo': 'Applies to',
    'moreInfo': 'More Information...',
    'informational': 'Informational',

  },
  
}

export default strings;
